import { canonicalIdBase } from '@core-mkt/services/schema/schema-id.util';
import { SchemaOrgNode } from '@core-mkt/services/schema/schema-org-node.model';
import { ProductItem } from './product-card';

/**
 * Builds a Schema.org ItemList node referencing each product card's course by URN.
 * Cards without a resolvable Course `@id` (no xgritProductId) are excluded so the
 * list never emits `ListItem`s with a missing `item`, and `numberOfItems`/positions
 * reflect only the resolvable courses. Returns `null` when no Course IDs are present.
 */
export function getProductCardSchema(items: ProductItem[], pageUrl: string): SchemaOrgNode | null {
  if (!items || items.length === 0) {
    return null;
  }

  const courseIds = items
    .map((item) => item.xGritProduct?.craftData?.xgritProductId)
    .filter((productId): productId is string => productId != null && productId !== '')
    .map((productId) => `urn:xgrit:course:${productId}`);

  if (courseIds.length === 0) {
    return null;
  }

  const itemListElement = courseIds.map((courseId, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: { '@id': courseId },
  }));

  return {
    '@type': 'ItemList',
    '@id': `${canonicalIdBase(pageUrl)}#courses`,
    numberOfItems: courseIds.length,
    itemListElement,
  };
}
